import React from 'react'
import styled from 'styled-components'

import commonCss from '~/core/css'
import ScrollObserver from './scroll-observer'
import Spinner from './spinner'

const Container = styled.div`
  display: flex;
  ${({ orientation }) => orientation === 'vertical' || !orientation
  ? `
  flex-direction: column;
  min-height: 100%;
  `
: ''}
  
  & > * {
    flex: 0
  }
`

const StyledSpinner = styled(Spinner)`
  flex: 1;
  margin: ${({ orientation }) => orientation === 'vertical' || !orientation ? '10px 0' : '0 10px'};
  position: relative;

  & > svg {
    transform: scale(0.75);
    visibility: ${props => props.isFetching ? 'visible' : 'hidden'};
  }
`

const ListContainer = styled.div`
  ${commonCss.fixListSize};
`

export const InfiniteList = ({
  children,
  className,
  disableScrolling,
  fetchMore,
  isFetching,
  skeletonConfig,
  orientation
}) => {
  const getLoadingIndicator = () => {
    if (skeletonConfig) {
      if (isFetching) {
        return Array.from(Array(skeletonConfig.pageSize).keys()).map(index => <skeletonConfig.Loader key={index} />)
      }

      return <StyledSpinner orientation={orientation} />
    }

    return (
      <StyledSpinner
        key='infinite-list-spinner'
        isFetching={isFetching}
        orientation={orientation}
      />
    )
  }

  return (
    <ListContainer
      className={className}
      role='list'
    >
      <ScrollObserver
        disableScrolling={disableScrolling}
        onMaxScroll={fetchMore}
        orientation={orientation}
      >
        <Container
          key='infinite-list-container'
          orientation={orientation}
        >
          {children}
          {getLoadingIndicator()}
        </Container>
      </ScrollObserver>
    </ListContainer>
  )
}

InfiniteList.defaultProps = {
  fetchMore: () => { }
}

export default InfiniteList
